import React from 'react';
import icCheckbox from './ic_checkbox.svg';
import icCheckboxActive from './ic_checkbox-active.svg';
import icCheckboxRound from './ic_round.svg';
import icCheckboxRoundActive from './ic_round-active.svg';
import styled from 'styled-components';
import clsx from 'clsx';
type Props = {
  label?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  round?: boolean;
  size?: 'small' | 'medium' | 'large';
};
const Checkbox = ({ label, value, onChange, style, disabled, round, size = 'medium' }: Props) => {
  const imgSize = size === 'small' ? 16 : size === 'medium' ? 24 : 32;

  return (
    <Container
      onClick={() => !disabled && onChange?.(!value)}
      style={style}
      className={clsx('checkbox-container', disabled ? 'disabled' : '')}
    >
      <img
        src={
          round
            ? value
              ? icCheckboxRoundActive
              : icCheckboxRound
            : value
            ? icCheckboxActive
            : icCheckbox
        }
        alt='checkbox'
        style={{ width: imgSize, height: imgSize }}
      />
      <span>{label}</span>
    </Container>
  );
};

export default Checkbox;

const Container = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    cursor: pointer;
  }
  span {
    color: #1d2129;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
`;
